import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import moment from "moment"
import { Dropdown } from "primereact/dropdown"
import { InputText } from "primereact/inputtext"
import { useTranslation } from "react-i18next"
import { DATE_YYYY_MM_DD } from "../../constants"

const FechaFilter = ({
  fechaDrodownActive,
  onGetSelectValues,
  dateKeys,
  rangeDateOption,
  handleDate,
  handleCustomDate,
  date,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()

  const getDateForInputs = (date: $TSMigrationFixMe) => {
    return date ? moment(date).format(DATE_YYYY_MM_DD) : null
  }
  return (
    <div className='px-2'>
      <div className='mt-2 mb-2 filter-title align-items-center'>
        <FontAwesomeIcon icon={["fal", "calendar-lines"]} />
        <h5>{t("filtros.fecha.title")}</h5>
      </div>
      <div className='px-2 p-fluid p-grid p-formgrid justify-content-center'>
        {fechaDrodownActive ? (
          <div className='p-0 p-field col-12 d-flex p-dir-col align-items-start'>
            <label
              htmlFor='importeDesde'
              className='align-items-start'
            >
              {t("filtros.fecha.rangeLabel")}
            </label>
            <Dropdown
              // @ts-expect-error TS(2769): No overload matches this call.
              placeholder={t("filtros.fecha.placeholderSelectedOne")}
              options={onGetSelectValues()}
              className='rounded-none w-100'
              name='tipoDocumento'
              id='tipoDocumento'
              onChange={(option) => handleDate(option, dateKeys[0])}
              value={rangeDateOption}
              panelClassName='!tw-z-[2302]'
            />
          </div>
        ) : null}
      </div>
      <div className='mt-1 p-fluid p-grid'>
        <div className='p-fluid p-grid p-formgrid justify-content-center'>
          <div className='p-0 p-field col-5 d-flex p-dir-col align-items-start '>
            <label htmlFor='importeDesde'>{t("filtros.fecha.fromLabel")}</label>
            <InputText
              onChange={(e) => {
                return handleCustomDate(e, dateKeys[0])
              }}
              // @ts-expect-error TS(2769): No overload matches this call.
              value={getDateForInputs(date[[dateKeys[0]]])}
              minFractionDigits={2}
              type='date'
            />
          </div>
          <div className='mt-4 p-field d-flex justify-content-center col-1 align-items-center'>
            -
          </div>
          <div className='p-0 p-field col-5 d-flex p-dir-col align-items-start'>
            <label htmlFor='importeHasta'>{t("filtros.fecha.toLabel")}</label>
            <InputText
              onChange={(e) => {
                return handleCustomDate(e, dateKeys[1])
              }}
              // @ts-expect-error TS(2769): No overload matches this call.
              value={getDateForInputs(date[[dateKeys[1]]])}
              minFractionDigits={2}
              type='date'
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default FechaFilter
